import { Link } from "react-router";
import { cn } from "@/lib/utils";
import {
  isPublishable,
  PRIVACY_DOC,
  TERMS_DOC,
  type LegalDoc,
} from "./legalDocs";

/** Ligas de pie a los textos legales; las de un texto con marcadores {{ }} se ocultan. */
export const LegalLinks = ({
  className,
  docs = [PRIVACY_DOC, TERMS_DOC],
  onNavigate,
}: {
  className?: string;
  docs?: LegalDoc[];
  onNavigate?: () => void;
}) => {
  const visible = docs.filter((d) => isPublishable(d.md));
  if (!visible.length) return null;
  return (
    <div
      className={cn(
        "flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground",
        className,
      )}
    >
      {visible.map((d) => (
        <Link
          key={d.path}
          to={d.path}
          onClick={onNavigate}
          className="underline hover:no-underline"
        >
          {d.label}
        </Link>
      ))}
    </div>
  );
};
